import { createFileRoute } from "@tanstack/react-router";

import { ConnectErrorPage } from "@/connect/ConnectErrorPage";
import { validateConnectErrorSearch } from "@/connect/search";

export const Route = createFileRoute("/conectar/error")({
  validateSearch: validateConnectErrorSearch,
  component: ConnectErrorPage,
});
